import React from 'react';

const SimilarArticles = React.lazy(() => import(/* webpackChunkName: "redesign__components__SimilarArticles" */"../../../../redesign/components/SimilarArticles"));
const Taboola = React.lazy(() => import(/* webpackChunkName: "redesign__components__Taboola" */"../../../../redesign/components/Taboola"));

interface ISimilarArticlesWithTaboola {
    ArticleStore: any;
    isDesktop?: boolean;
    isSemi?: boolean;
    analyticsMode: 'only' | 'withArticles';
}

const SimilarArticlesWithTaboola: React.FC<ISimilarArticlesWithTaboola> = ({ ArticleStore, isDesktop, isSemi, analyticsMode }) => {

    return (
        <>
            <Taboola displaySimiliarArticles={analyticsMode !== 'only'} />
            {analyticsMode !== 'only' && (!isDesktop || isSemi) && <SimilarArticles articles={ArticleStore.similar_articles} />}
        </>
    );

};

export default SimilarArticlesWithTaboola